<div class="header" [ngClass]="{ 'sticky-header': isScrolled , 'dev-server' : isDev }" [class.not-home]="!isHome" *ngIf="!noHeaders">
  <div>
    <a class="show-menu" (click)="menuToggle()" [class.open-menu]="isOpen"></a>
    <store-cart class="store-cart-mobile"></store-cart>
    <h3 class="title-from-another-component">{{ currentPageTitle }}</h3>
    <a [href]="homeUrl" class="logo"></a>
    <div class="sp-container hide-in-responsive" [class.open]="isOpen">
      <div class="sp-row custom-sp-row">
        <div class="">
          <ul class="main-menu">
            <li><a [href]="homeUrl">الرئيسية</a></li>
            <li><a [href]="discoverUrl">اكتشف</a></li>
            <li><a routerLink="/home/requests" routerLinkActive="current">تسعيراتي</a></li>
            <li><a routerLink="/home/orders" routerLinkActive="current">مشترياتي</a></li>
            <li><a routerLink="/home/car-services" routerLinkActive="current">خدمات سيارتي</a></li>
            <li><a routerLink="/home/wallet" routerLinkActive="current">رصيد سبيرو</a></li>
          </ul>
        </div>
        <div class="">
          <div class="left_header">
            <div class="cart">
              <store-cart></store-cart>
            </div>
            <div class="notification">
              <app-notification-widget></app-notification-widget>
            </div>
            <div class="profile_widget">
              <app-profile-widget></app-profile-widget>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-menu" [class.open]="isOpen">
      <ul class="mobile-main-menu">
        <li><a (click)="menuToggle()" [href]="homeUrl">الرئيسية</a></li>
        <li><a (click)="menuToggle()" [href]="discoverUrl">اكتشف</a></li>
        <li><a (click)="menuToggle()" routerLink="/about-us">عن سبيرو</a></li>
        <li><a (click)="menuToggle()" routerLink="/home/requests" *ngIf="isAuthenticated">تسعيراتي</a></li>
        <li><a (click)="menuToggle()" routerLink="/home/orders" *ngIf="isAuthenticated">مشترياتي</a></li>
        <li><a (click)="menuToggle()" routerLink="/home/car-services" *ngIf="isAuthenticated">خدمات سيارتي</a></li>
        <li><a (click)="menuToggle()" routerLink="/home/new-request" *ngIf="isAuthenticated">طلب جديد</a></li>
        <li><a (click)="menuToggle()" routerLink="/home/profile" *ngIf="isAuthenticated">حسابي</a></li>
        <li><a (click)="menuToggle()" routerLink="/workshop-application">سبيرو للورش و الشركات</a></li>
        <li><a (click)="menuToggle()" href="https://support.speero.net" target="_blank">الاسئلة الشائعة</a></li>
        <li><a (click)="menuToggle()" href="https://support.speero.net" target="_blank">مركز خدمة العملاء</a></li>
        <li><a (click)="menuToggle()" href="https://speero.workable.com">انضم الى فريق العمل</a></li>
        <li><a (click)="menuToggle()" routerLink="/contact-us">اتصل بنا</a></li>
        <li><a (click)="menuToggle()" routerLink="/home/wallet">رصيد سبيرو</a></li>
      </ul>
      <a (click)="menuToggle()" routerLink="/login" class="login" *ngIf="!isAuthenticated">الدخول</a>
      <a class="login" (click)="logOut()" *ngIf="isAuthenticated">تسجيل خروج</a>
    </div>
  </div>
</div>
-
